import { Types } from '@amplitude/analytics-browser';

// Spotlight and Spotlight Next Gen send to the same Amplitude project. This property lets
// charts filter or group by the UI that produced each event. Next Gen sends 'Next Gen'
// (d2c-admin-tools/apps/spotlight-ui); keep the key and values in sync with it.
// cfaone-giveaway-ui sends the same property to its own project.
export const UI_VERSION_PROPERTY = 'UI Version';
export const UI_VERSION = 'Legacy';

export function createUiVersionEnrichmentPlugin(): Types.EnrichmentPlugin {
  return {
    name: 'ui-version',
    type: 'enrichment',
    execute: (event: Types.Event): Promise<Types.Event> => {
      // Identify/group identify events carry user properties, not event properties.
      if (!event.event_type.startsWith('$')) {
        event.event_properties = { ...event.event_properties, [UI_VERSION_PROPERTY]: UI_VERSION };
      }
      return Promise.resolve(event);
    },
  };
}
